import _ = require('underscore');
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IExtractConvertAction } from '../../../../ts/ServerApi/types/actionNames';
import { changeExtractDsToLive } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { isWorkbookSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanCreateExtractOnEmbeddedDs } from './IEntityActionHelpers';

export const ChangeExtractEmbeddedDsToLiveAction: IEntityAction<IDataSourceInfo, IExtractConvertAction> = {
  name: EntityActionNames.ChangeExtractDsToLiveEmb,
  translateName: Messages.changeExtractDsToLiveAction,
  isVisible: (targetItems: IDataSourceInfo[], state: AppState) => {
    if(!CompositeSessionInfoSelectors.isWebExtractionEnabled(state)){
      return false;
    }
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    return isWorkbookSpace(spaceInfo) && _.any(targetItems, (targetItem) => targetItem.contentType === 'datasource');
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
    return userCanCreateExtractOnEmbeddedDs(state) &&
      _.any(targetItems, (targetItem) => targetItem.hasExtracts && !targetItem.isExtractOnly && !targetItem.isFileBased && targetItem.connectionType !== 'sqlproxy');
  },
  isChecked: (availableActions: {}, targetItems: IDataSourceInfo[], state: AppState) => {
    return _.all(targetItems, (targetItem) => !targetItem.hasExtracts);
  },
  createReduxAction: (dataSources: IDataSourceInfo[]) => changeExtractDsToLive(dataSources)
};
